/**
 * @class service_v3sListbox
 * @memberOf v3sWbtPlayerApp:exercise:listbox
 */
angular.module('v3sWbtPlayerApp').factory('v3sListboxElement', ['v3sExerciseService', 'v3sExerciseElement', function (v3sExerciseService, v3sExerciseElement) {
    var v3sListboxElement = function (id, type) {
        this.id = id;
        this.userAnswer = '';
        this.items = [];
        this.load();
    }

    // Create nue v3sExerciseElement
    v3sListboxElement.prototype = new v3sExerciseElement();

    // Add an Item
    v3sListboxElement.prototype.addItem = function (item) {
        this.items.push(item);
    }

    //Check if option is correct
    v3sListboxElement.prototype.isCorrect = function (index) {
        return (this.items[index].correct == 1);
    }
    v3sListboxElement.prototype.setUserAnswer = function (answer) {
        this.userAnswer = answer;

        if (this.userAnswer >= 0) {
            if (this.isCorrect(this.userAnswer)) {
                this.status = this.STATUS.CORRECT;
            } else {
                this.status = this.STATUS.FALSE;
            }
            this.save();
        } else {
            this.status = this.STATUS.NO_ANSWER;
        }
    }

    v3sListboxElement.prototype.getUserAnswer = function () {
        return this.userAnswer;
    }

    return v3sListboxElement;
}]);